import React from 'react';
import { useDeviceDetection } from '../hooks/useDeviceDetection';
import { DashboardView } from './DashboardView';
import DashboardMovilView from './DashboardMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra
 * la versión apropiada del dashboard
 */
const DashboardAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();

  // Considerar tablets como móvil
  const esMobileOTablet = isMobile || isTablet;

  // Renderizar versión móvil o desktop según el dispositivo
  if (esMobileOTablet) {
    return <DashboardMovilView />;
  }

  return <DashboardView />;
};

export default DashboardAutoView;
